import Router from '../core'

Router.previousRoute = Router.currentRoute

Router.beforeResolve((to, from, next) => {
    Router.previousRoute = Router.currentRoute
    next()
})
